<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      item-text="name"
      item-value="uid"
      :label="label"
      clearable
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {GlobalConfig} from "@/modules/redactor/models/global-config/GlobalConfig";

export default {
  name: "r-global-config-dropdown",
  props: {
    label: VueTypes.string.def("Select Config"),
    model: VueTypes.instanceOf(GlobalConfig),
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return RedactorUtils.getGlobalConfigs();
    }
  }
}

</script>